import { isMarketingAllowed } from './consent';
import { isStaffAnalyticsSession } from './staffAnalytics';

const GOOGLE_ADS_TAG_ID = 'AW-812222019';

/** Send the website identity signal matched to our offline purchase imports. */
export function sendGoogleAdsSignup(email: string) {
  if (
    process.env.ENV !== 'production' ||
    !email.trim() ||
    !isMarketingAllowed() ||
    isStaffAnalyticsSession()
  ) {
    return;
  }

  // RudderStack installs/configures the Ads tag. Wait for device destinations
  // before sending, then recheck consent in case it changed while loading.
  try {
    window.rudderanalytics?.ready?.(() => {
      if (!isMarketingAllowed() || isStaffAnalyticsSession()) return;

      // Google's enhanced-conversions-for-leads protocol sends form_submit.
      // Keep this transport out of Rudder's general signup event and GA4;
      // purchase conversions continue to come only from the warehouse.
      try {
        window.gtag?.('set', 'user_data', { email: email.trim() });
        window.gtag?.('event', 'form_submit', { send_to: GOOGLE_ADS_TAG_ID });
      } catch {
        // Tag failures must not affect a completed signup either.
      }
    });
  } catch {
    // A blocked or unavailable analytics SDK must not interrupt signup.
  }
}
